import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import {
  AddButton,
  Buttons,
  CancelButton,
  DeleteButton,
  UpdateButton,
} from '../../../components/Common/iComponents/iPopUp/IpopUp';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';
import { useSelector, useDispatch } from 'react-redux';
import { getClients, getTasks } from '../../../store/actions';
import { Label, FormGroup } from 'reactstrap';

const FormConfigTask = ({
  selectedRow,
  onCreateConfigTask,
  onUpdateConfigTask,
  onDeleteConfigTask,
  onCancel,
}: any) => {
  const arrayUpdAdd = [
    'repetirCada',
    'clienteId',
    'tareaId',
    'enabled',
    'workflow',
  ];
  const columsPop = 1;
  const [form, setForm] = useState({
    empresa: '',
    clienteId: '',
    tareaId: '',
    repetirCada: '',
    enabled: false,
    workflow: false,
  });
  const [flag, setflag] = useState<any>(true);

  const { tasks, CountItems } = useSelector((state: any) => state.Tasks);
  const { clients } = useSelector((state: any) => state.clients);
  const valuesSizeRolesPagination = [50,100,150,200,250];

  const [paginationTasks, setPaginationTasks] = useState<any>({
    sizePerPage: valuesSizeRolesPagination[0],
    page: 1,
  });
  const dispatch = useDispatch();

  const initialArrayTableRoles = [
    {
      text: 'Id',
      dataField: 'id',
      formatter: (cellContent: any, tasks: any) => <>{tasks.id}</>,
      hidden: false,
    },
    {
      text: 'Description',
      dataField: 'descripcion',
      formatter: (cellContent: any, tasks: any) => <>{tasks.descripcion}</>,
      hidden: false,
    },
  ];
  const initialArrayTableClients = [
    {
      text: 'Id',
      dataField: 'id',
      formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
      hidden: false,
    },
    {
      text: 'Name',
      dataField: 'name',
      formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
      hidden: false,
    },
  ];

  const handlePaginationTasksChange = (newState: any) => {
    setPaginationTasks(newState);
  };

  useEffect(() => {
    if (selectedRow) {
      if (tasks.length === 0) {
        dispatch(getTasks({ pagination: paginationTasks }));
      }
      if (clients.length === 0) {
        dispatch(getClients({}));
      }
      setForm(selectedRow);
    }
  }, [selectedRow]);

  useEffect(() => {
    dispatch(getClients({}));
    dispatch(getTasks({ pagination: paginationTasks }));
  }, [selectedRow, paginationTasks]);

  const itemVals = (val: any, updateVal: any) => {
    for (const property in updateVal) {
      if (property === val) {
        return updateVal[property];
      }
    }
  };
  const renderButtons = () => (
    <Buttons>
      {selectedRow ? (
        <>
          <CancelButton
            className="button"
            onClick={() => onCancel()}
            data-bs-toggle="tooltip"
          >
            <i
              className="bx bx-power-off"
              style={{ fontSize: '2.5em' }}
              data-bs-toggle="tooltip"
            ></i>
          </CancelButton>
          <DeleteButton
            className="btn-delete"
            onClick={() => onDeleteConfigTask(selectedRow.id)}
          >
            <i className="dripicons-trash" style={{ fontSize: '1.7em' }}></i>
          </DeleteButton>
          <UpdateButton
            className="button"
            disabled={flag}
            onClick={() => onUpdateConfigTask(form)}
          >
            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
          </UpdateButton>
        </>
      ) : (
        <AddButton
          type="submit"
          disabled={flag}
          className="btn"
          onClick={() => {
            onCreateConfigTask(form);
          }}
        >
          <i className="bx bx-user-check" style={{ fontSize: '3.5em' }} />
        </AddButton>
      )}
    </Buttons>
  );

  useEffect(() => {
    const { empresa, clienteId, tareaId, repetirCada } = form;
    if (empresa != '' && clienteId != '' && tareaId != '' && repetirCada) {
      if (empresa != '' && clienteId != '' && tareaId != '' && repetirCada) {
        setflag(false);
      }
    } else {
      setflag(true);
    }
  }, [form]);

  useEffect(() => {
    const clientCompany = clients.filter(
      (item: any) => Number(item.id) === Number(form?.clienteId),
    )[0]?.company;
    if (clientCompany) setForm({ ...form, empresa: String(clientCompany) });
  }, [form?.clienteId, clients]);

  const onChangeBooleanHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: !form[n as keyof typeof form],
    });
  };
  const onChangeSelectorHandler = (n: any, value: any) => {
    setForm({
      ...form,
      [n]: String(value.id),
    });
  };

  const onChangeHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: e.target.value,
    });
  };

  return (
    <>
      <div style={{ width: '650px', height: '450px' }}>
        <AvForm
          className="custom-form mt-0"
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
            gridAutoRows: 'minmax(10%, 90px)',
            gridGap: '2%',
            padding: '0',
            marginLeft: '15%',
            paddingTop: '4%',
          }}
        >
          {arrayUpdAdd?.map((val: any) => {
            const nameObject = val as keyof typeof form;
            const firstLet = val[0].toUpperCase();
            const rest = val.slice(1);
            const word = firstLet + rest;
            const temp = form[nameObject];
            const valid = temp ? true : false;
            let type = '';
            let nameSelector = '';
            const value = selectedRow ? itemVals(val, selectedRow) : null;

            switch (val) {
              case 'tareaId':
                nameSelector =
                  value || value === null
                    ? tasks.filter(
                        (item: any) => Number(item.id) === Number(temp),
                      )[0]?.descripcion
                    : '';
                return (
                  <ISelector
                    title={val}
                    value={String(temp)}
                    nameSelector={nameSelector ?? ''}
                    valuesSizePagination={valuesSizeRolesPagination}
                    dataSelector={tasks}
                    remote={true}
                    CountItems={CountItems}
                    initialArrayTable={initialArrayTableRoles}
                    handlePaginationChange={handlePaginationTasksChange}
                    setSelectedRow={onChangeSelectorHandler}
                    onChangeHandler={onChangeHandler}
                  />
                );
              case 'clienteId': {
                const clientInfo = clients.filter(
                  (item: any) => Number(item.id) === Number(temp),
                )[0];
                nameSelector = value || value === null ? clientInfo?.name : '';
                return (
                  <ISelector
                    title={val}
                    value={String(temp)}
                    nameSelector={nameSelector ?? ''}
                    dataSelector={clients}
                    CountItems={'20'}
                    initialArrayTable={initialArrayTableClients}
                    setSelectedRow={onChangeSelectorHandler}
                    onChangeHandler={onChangeHandler}
                  />
                );
              }
              case 'enabled':
                return (
                  <div
                    style={{
                      position: 'relative',
                      width: 50,
                      left: '150px',
                      zIndex: 99,
                    }}
                  >
                    <FormGroup className="text-center">
                      <div className="text-capitalize">
                        <Label>{val}</Label>
                      </div>
                      <Label>
                        <ISwitch
                          title={val}
                          checked={Boolean(form[nameObject])}
                          onChangeBooleanHandler={onChangeBooleanHandler}
                        />
                      </Label>
                    </FormGroup>
                  </div>
                );
              case 'empresa':
                type = 'number';
                break;
              default:
                type = 'text';
                break;

              case 'workflow':
                return (
                  <div
                    style={{
                      position: 'relative',
                      left: '20px',
                      bottom: '91px',
                    }}
                  >
                    <FormGroup className="text-center">
                      <div className="text-capitalize">
                        <Label>{val}</Label>
                      </div>
                      <Label>
                        <ISwitch
                          title={val}
                          checked={Boolean(form[nameObject])}
                          onChangeBooleanHandler={onChangeBooleanHandler}
                        />
                      </Label>
                    </FormGroup>
                  </div>
                );
            }
            return (
              <IInput
                title={val}
                valid={valid}
                value={value}
                type={type}
                onChangeHandler={onChangeHandler}
              />
            );
          })}
        </AvForm>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '1%',
          marginRight: '1%',
        }}
      >
        {renderButtons()}
      </div>
    </>
  );
};

FormConfigTask.propTypes = {
  selectedRow: PropTypes.object,
  onCreateConfigTask: PropTypes.func,
  onUpdateConfigTask: PropTypes.func,
  onDeleteConfigTask: PropTypes.func,
  onCancel: PropTypes.func,
};

export default FormConfigTask;
